/* NEULO waiting-list routing. Only the two declared waiting-list form mounts are touched. */
(function () {
  'use strict';
  const roots = Array.from(document.querySelectorAll('[data-neulo-waitlist-router]'));
  if (!roots.length) return;
  // Preview must never send registrations through the shared, live PFB forms.
  const preview = document.querySelector('script[data-neulo-consent-preview]')?.dataset.neuloConsentPreview !== 'false';
  const japanese = (document.documentElement.lang || '').toLowerCase().split('-')[0] === 'ja';
  const labels = japanese ? {
    country: '居住国', choose: 'お住まいの国を選択してください',
    loading: 'フォームを読み込み中です。', error: 'フォームを読み込めませんでした。ページを再読み込みしてください。',
    mismatch: '居住国を選び直してから、もう一度登録してください。'
  } : {
    country: 'Country of residence', choose: 'Please select your country of residence',
    loading: 'Loading the form…', error: 'The form could not be loaded. Please reload this page.',
    mismatch: 'Please select your country of residence again before submitting.'
  };
  roots.forEach(function (root, index) {
    const loading = root.querySelector('.neulo-waitlist-loading');
    if (loading) loading.textContent = labels.loading;
    const panels = {global: root.querySelector('[data-waitlist-panel="global"]'), domestic: root.querySelector('[data-waitlist-panel="domestic"]')};
    let selector, current = null, submitting = false, succeeded = false;
    const countryField = panel => panel && panel.querySelector('select[name="select-2"]');
    const targetFor = country => japanese && country === 'Japan' ? 'domestic' : 'global';
    const notify = element => { element.dispatchEvent(new Event('input', {bubbles:true})); element.dispatchEvent(new Event('change', {bubbles:true})); };
    function copyInputs(from, to) {
      if (!from || !to || from === to) return;
      // Preserve user-entered fields only. Never copy form IDs, integration fields, hidden values or tokens.
      ['text-1','text','email','select-1'].forEach(function(name) {
        const source = Array.from(from.querySelectorAll('input,select')).find(e => e.name === name);
        const dest = Array.from(to.querySelectorAll('input,select')).find(e => e.name === name);
        if (!source || !dest) return;
        if (source.type === 'checkbox') dest.checked = source.checked; else dest.value = source.value;
        notify(dest);
      });
    }
    function reflectCountry() {
      if (!selector) return;
      const residence = selector.value;
      Object.values(panels).forEach(function(panel) {
        const field = countryField(panel);
        if (field && field.value !== residence) { field.value = residence; notify(field); }
        if (residence !== 'Japan') {
          const prefecture = panel.querySelector('select[name="select-1"]');
          if (prefecture && prefecture.value) { prefecture.value = ''; notify(prefecture); }
        }
      });
    }
    function choose() {
      if (submitting) return;
      // Show a complete form before country selection; submission still requires an explicit country.
      const next = selector.value ? targetFor(selector.value) : (japanese ? 'domestic' : 'global');
      if (next && current !== next) copyInputs(panels[current], panels[next]);
      current = next;
      root.dataset.countryPending = String(!selector.value);
      reflectCountry();
      Object.entries(panels).forEach(function([key,panel]) {
        panel.dataset.active = String(key === current);
        panel.inert = key !== current;
        panel.setAttribute('aria-hidden', String(key !== current));
      });
      root.querySelector('.neulo-waitlist-error')?.remove();
    }
    function translateGlobalForm() {
      if (japanese || !panels.global) return;
      const translations = {
        'ローンチ日・先行枠・最新アップデートを、登録者に優先配信します。': 'Sign up for new colours, events and updates from NEULO.',
        "都道府県": "Prefecture", "都道府県 *": "Prefecture *", "都道府県を選択": "Select a prefecture", "北海道": "Hokkaido", "青森県": "Aomori", "岩手県": "Iwate", "宮城県": "Miyagi", "秋田県": "Akita", "山形県": "Yamagata", "福島県": "Fukushima", "茨城県": "Ibaraki", "栃木県": "Tochigi", "群馬県": "Gunma", "埼玉県": "Saitama", "千葉県": "Chiba", "東京都": "Tokyo", "神奈川県": "Kanagawa", "新潟県": "Niigata", "富山県": "Toyama", "石川県": "Ishikawa", "福井県": "Fukui", "山梨県": "Yamanashi", "長野県": "Nagano", "岐阜県": "Gifu", "静岡県": "Shizuoka", "愛知県": "Aichi", "三重県": "Mie", "滋賀県": "Shiga", "京都府": "Kyoto", "大阪府": "Osaka", "兵庫県": "Hyogo", "奈良県": "Nara", "和歌山県": "Wakayama", "鳥取県": "Tottori", "島根県": "Shimane", "岡山県": "Okayama", "広島県": "Hiroshima", "山口県": "Yamaguchi", "徳島県": "Tokushima", "香川県": "Kagawa", "愛媛県": "Ehime", "高知県": "Kochi", "福岡県": "Fukuoka", "佐賀県": "Saga", "長崎県": "Nagasaki", "熊本県": "Kumamoto", "大分県": "Oita", "宮崎県": "Miyazaki", "鹿児島県": "Kagoshima", "沖縄県": "Okinawa",
        '姓': 'Last name', '名': 'First name', '姓 *': 'Last name *', '名 *': 'First name *',
        'プライバシーポリシー': 'Privacy Policy', 'に合意する': 'I agree to the Privacy Policy'
      };
      const walker = document.createTreeWalker(panels.global, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const value = node.textContent.trim();
        if (translations[value]) {
          const option = node.parentElement;
          // Options without an explicit value derive it from their label.
          if (option?.tagName === 'OPTION' && !option.hasAttribute('value')) option.setAttribute('value', option.value);
          node.textContent = node.textContent.replace(value, translations[value]);
        }
      }
      panels.global.querySelectorAll('input[placeholder]').forEach(function(input) {
        if (translations[input.placeholder]) input.placeholder = translations[input.placeholder];
      });
      panels.global.querySelectorAll('a[href*="/policies/privacy-policy"]').forEach(function(link) {
        if (!link.getAttribute('href').includes('/en/')) link.setAttribute('href', '/en/policies/privacy-policy');
      });
    }
    function initialize() {
      if (selector) return;
      const original = countryField(panels.global);
      if (!original || !countryField(panels.domestic)) return;
      const field = document.createElement('div'); field.className = 'neulo-residence';
      const label = document.createElement('label'); label.htmlFor = 'neulo-residence-' + index; label.textContent = labels.country + ' *';
      selector = document.createElement('select'); selector.id = label.htmlFor; selector.required = true;
      const empty = document.createElement('option'); empty.value = ''; empty.textContent = labels.choose; empty.disabled = true; empty.selected = true; selector.appendChild(empty);
      Array.from(original.options).filter(o => o.value).forEach(function(option) { const copy = document.createElement('option'); copy.value = option.value; copy.textContent = option.textContent; selector.appendChild(copy); });
      field.append(label,selector); root.insertBefore(field,root.firstChild); if (loading) loading.remove();
      selector.value = ''; selector.addEventListener('change', choose); choose();
    }
    function error() {
      if (!root.querySelector('.neulo-waitlist-error')) {const p=document.createElement('p');p.className='neulo-waitlist-error';p.setAttribute('role','alert');p.textContent=labels.mismatch;root.prepend(p);}
      selector?.focus();
    }
    function consentNotices() {
      Object.values(panels).forEach(function(panel) {
        if (!panel) return;
        const form = panel.querySelector('form');
        const footer = form?.querySelector('.gfb__page-footer');
        const button = footer?.querySelector('button[type="submit"]');
        const legacy = form?.querySelector('input[data-type="consent"][name="consent-1[]"]');
        const wrapper = legacy?.closest('.checkbox-wrapper');
        if (!button || !wrapper) return;
        if (!wrapper.hasAttribute('data-neulo-implicit-consent')) {
          legacy.checked = false;
          wrapper.dataset.neuloImplicitConsent = '';
          wrapper.hidden = true;
        }
        const control = legacy.closest('.globo-form-control[data-element-id="consent-1"]');
        if (control && !control.hasAttribute('data-neulo-implicit-consent')) {
          control.dataset.neuloImplicitConsent = '';
          control.hidden = true;
        }
        if (footer.querySelector('.neulo-waitlist-consent')) return;
        const notice = document.createElement('p');
        notice.className = 'neulo-waitlist-consent';
        notice.dataset.consentVersion = 'signup-20261101';
        notice.id = 'neulo-waitlist-consent-' + form.dataset.id + '-' + index;
        notice.innerHTML = japanese
          ? '「Waiting Listに登録」を押すと、<a href="/policies/privacy-policy" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>に同意し、NEULOからのメールマガジンの配信に同意したことになります。配信はメール内のリンクからいつでも停止できます。'
          : 'By selecting “Join the waiting list”, you agree to our <a href="/en/policies/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and to receive marketing emails from NEULO. You can unsubscribe at any time using the link in our emails.';
        footer.insertBefore(notice, footer.firstChild);
        // Keep the existing PFB evidence field, but record it only when the user submits.
        legacy.checked = false;
        button.setAttribute('aria-describedby', [button.getAttribute('aria-describedby'), notice.id].filter(Boolean).join(' '));
        // Match the action named by the consent notice, including PFB's idle label.
        const caption = japanese ? 'Waiting Listに登録' : 'Join the waiting list';
        const label = '<span class="spinner"></span>' + caption;
        button.innerHTML = label;
        button.setAttribute('data-submit-text', label);
      });
    }
    root.addEventListener('submit', function(event) {
      const panel = event.target.closest('[data-waitlist-panel]');
      if (!panel) return;
      const actualCountry = countryField(panel)?.value;
      const expectedId = panel.dataset.waitlistPanel === 'domestic' ? '163837' : '128186';
      if (submitting || !selector?.value || panel.dataset.waitlistPanel !== current || targetFor(selector.value) !== current || actualCountry !== selector.value || event.target.getAttribute('data-id') !== expectedId) {
        event.preventDefault(); event.stopImmediatePropagation(); if (!submitting) error();
        return;
      }
      const notice = event.target.querySelector('.neulo-waitlist-consent');
      const consent = event.target.querySelector('input[data-type="consent"][name="consent-1[]"]');
      if (preview || !notice || !consent || notice.dataset.consentVersion !== 'signup-20261101') {
        event.preventDefault(); event.stopImmediatePropagation();
        let message = root.querySelector('.neulo-waitlist-error');
        if (!message) {message=document.createElement('p');message.className='neulo-waitlist-error';message.setAttribute('role','alert');root.prepend(message);}
        message.textContent = preview
          ? (japanese ? '未公開プレビューのため、登録は送信されません。' : 'Preview only. Your registration has not been sent.')
          : (japanese ? '同意の案内を読み込めませんでした。ページを再読み込みしてください。' : 'The consent notice could not be loaded. Please reload this page.');
        return;
      }
      consent.checked = true; notify(consent);
    }, true);
    document.addEventListener('globo.formbuilder.form.loaded', function(event) {
      if (!root.contains(event.detail?.form)) return;
      initialize(); translateGlobalForm(); reflectCountry(); consentNotices();
    });
    document.addEventListener('globo.formbuilder.form.submitting', function(event) {
      if (!root.contains(event.detail?.form)) return;
      submitting = true; if (selector) selector.disabled = true;
    });
    document.addEventListener('globo.formbuilder.form.submitted', function(event) {
      if (!root.contains(event.detail?.form)) return;
      succeeded = true;
      // Let PFB perform the one configured redirect. Do not add another submit, email or conversion event.
    });
    const observer = new MutationObserver(function () {
      initialize(); translateGlobalForm(); consentNotices();
      // PFB clears its loading class on validation/network failure; allow a deliberate retry.
      if (submitting && !succeeded && !root.querySelector('.action.loading,button.loading')) {
        submitting = false; if (selector) selector.disabled = false;
      }
    });
    observer.observe(root, {subtree:true,childList:true,attributes:true,attributeFilter:['class','disabled']});
    initialize(); consentNotices();
    setTimeout(function () { if (!selector && loading) { loading.textContent = labels.error; loading.setAttribute('role','alert'); } }, 15000);
  });
})();
